import React from 'react';
import TableRow from 'components/Table/TableRow';
import TableBodyCell from 'components/Table/TableBodyCell';
import SkeletonRectangle from 'components/Skeleton/SkeletonRectangle';
import TableActionCell from 'components/Table/TableActionCell';
import { DecisionResultListColumnSizes } from 'components/DecisionResultsView/DecisionResultsTable/TableColumnSizes';

const SkeletonDecisionResultLine = () => {
  return (
    <TableRow disableHover useActions>
      <TableBodyCell width={DecisionResultListColumnSizes.Name}>
        <SkeletonRectangle width="80%" height="16px" color="primary6" />
      </TableBodyCell>
      <TableBodyCell width={DecisionResultListColumnSizes.Name}>
        <SkeletonRectangle width="80%" height="16px" color="primary6" />
      </TableBodyCell>
      <TableBodyCell width={DecisionResultListColumnSizes.ExecutionTime}>
        <SkeletonRectangle width="80%" height="16px" color="primary6" />
      </TableBodyCell>
      <TableBodyCell width={DecisionResultListColumnSizes.Type}>
        <SkeletonRectangle width="80%" height="16px" color="primary6" />
      </TableBodyCell>
      <TableActionCell />
    </TableRow>
  );
};

export default SkeletonDecisionResultLine;
